(function (){
    'use strict';

    angular
        .module('courseDirective', []);
})();